const games_fr = require('./games.json')
export default games_fr
